import React from "react";
import Appoinment from "../../Home/Appoinment/Appoinment";
import Content from "../AboutContent/Content";
import Achivement from "../Achivement/Achivement";
import Certificates from "../Certificates/Certificates";
import Banner from "../Banner/Banner";

const About = () => {
  return (
    <>
      <Banner />
      <Content />
      <Achivement />
      <Certificates />
      {/*<AboutService />
    <Dentist />*/}
      <Appoinment />
    </>
  );
};

export default About;
